import { preloadImages } from '@/utils/image';
import { isNil } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';

interface IFoldDropConceptParams {
  description: string | null;
}

const getImageUrlsFromHTML = (html: string) => {
  return [...html.matchAll(/(?:<img[^>]*src=["']?)([^>"']+)(?:["']?[^>]*>)/g)]
    .map(match => match.slice(1))
    .flat();
};

const preloadFirstTwoImages = (html: string) => {
  return preloadImages(getImageUrlsFromHTML(html).slice(0, 2));
};

export const useFoldDescription = ({ description }: IFoldDropConceptParams) => {
  const [isCalculating, setIsCalculating] = useState(true);
  const [isOverflown, setIsOverflown] = useState(false);

  useEffect(() => {
    if (isNil(description)) return;

    preloadFirstTwoImages(description);
  }, [description]);

  const htmlRefCallback = useCallback(
    (conceptDescriptionElement: HTMLDivElement | null) => {
      if (
        isNil(conceptDescriptionElement) ||
        isNil(conceptDescriptionElement.parentElement) ||
        isNil(description)
      )
        return;

      preloadFirstTwoImages(description).then(() => {
        requestAnimationFrame(() => {
          setIsCalculating(false);
          setIsOverflown(
            conceptDescriptionElement.clientHeight >
              conceptDescriptionElement.parentElement!.clientHeight
          );
        });
      });
    },
    [description]
  );

  return {
    isCalculating,
    isOverflown,
    htmlRefCallback,
  };
};
